"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartType = void 0;
var LineChartComponent_1 = require("@tableau/prediction-model-results-viz/lib/src/components/LineChartComponent");
Object.defineProperty(exports, "ChartType", { enumerable: true, get: function () { return LineChartComponent_1.ChartType; } });
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var ModelResultStyles_1 = require("../../../styles/ModelResultStyles");
var generateCoordinates = function (data, type) {
    return data
        .filter(function (d) {
        var targetData = type === LineChartComponent_1.ChartType.Gains ? 'cl' : 'ccr';
        return d.dataType === targetData;
    })
        .map(function (d) {
        return [d.cdf, d.value];
    });
};
var ModelResultCumulativeChart = function (_a) {
    var gainTable = _a.gainTable, chartType = _a.chartType, width = _a.width;
    var gainsTable = gainTable.gainsTable;
    var height = width; // make chart a square
    var coordinates = generateCoordinates(gainsTable, chartType);
    if (chartType === LineChartComponent_1.ChartType.Gains) {
        return (React.createElement("div", { className: ModelResultStyles_1.ChartContainer },
            React.createElement(LineChartComponent_1.LineChartComponent, { coordinates: coordinates, xAxisLabel: Localize_1.Messages.modelEvaluationCumulativeDataFraction(), yAxisLabel: Localize_1.Messages.modelEvaluationGain(), width: width, height: height })));
    }
    else if (chartType === LineChartComponent_1.ChartType.CumulativeCapture)
        return (React.createElement("div", { className: ModelResultStyles_1.ChartContainer },
            React.createElement(LineChartComponent_1.LineChartComponent, { coordinates: coordinates, xAxisLabel: Localize_1.Messages.modelEvaluationCumulativeDataFraction(), yAxisLabel: Localize_1.Messages.modelEvaluationCumulativeCaptureRate(), degree45Line: true, legend: { text: Localize_1.Messages.modelEvaluationValidationSet() }, width: width, height: height })));
    return null;
};
exports.default = ModelResultCumulativeChart;
//# sourceMappingURL=ModelResultCumulativeChart.js.map